import React, { useContext, useEffect, useState } from "react";
import "../styles/basketItemDiscount.css";
import "../styles/summary.css";
import { LanguageContext } from "../context/language/LanguageContext";
import appConst from "../Utilities/appConst.json";
import { useDispatch, useSelector } from "react-redux";
import { couponsActions } from "../store/couponsSlice";
import { Info } from "lucide-react";
import { alertActions } from "../store/alertSlice";
import IconButton from "../shared/IconButton";
import { Switch } from "./ui/switch";

export default function Coupon(props) {
  const languageContext = useContext(LanguageContext);
  const dispatch = useDispatch();
  const selectedCouponsIds = useSelector(
    (state) => state.coupons.selectedCouponsIds
  );
  const direction = useSelector((state) => state.mode.direction);
  const isRtl = direction === "rtl";
  const [isChecked, setIsChecked] = useState(false);
  const couponClasses = "summary_coupon_l summary_container";
  const switchTitle =
    props.coupon.display_method == appConst.GLOBAL_COUPON && !props.disabled
      ? props.coupon.message
      : "";
  const getIsExpiringSoon = (date, days) => {
    const minExpiringDate = new Date();
    minExpiringDate.setHours(0, 0, 0, 0);
    minExpiringDate.setDate(minExpiringDate.getDate() + days);

    const couponExpiringDate = new Date(date);
    couponExpiringDate.setHours(0, 0, 0, 0);

    const isExpiringSoon = minExpiringDate >= couponExpiringDate;

    return isExpiringSoon;
  };

  const isExpiringSoon = getIsExpiringSoon(
    props.coupon.expiration,
    appConst.MAX_EXPIRING_DAYS
  );

  useEffect(() => {
    if (props.coupon.display_method === appConst.SELECTABLE_COUPON) {
      if (selectedCouponsIds.find((id) => id === props.coupon.coupon_id)) {
        setIsChecked(true);
      } else {
        setIsChecked(false);
      }
    }
  }, [selectedCouponsIds]);

  const hendleChecked = () => {
    if (isChecked) {
      dispatch(
        couponsActions.removeFromSelectedCoupons({
          coupon: props.coupon,
        })
      );
    } else {
      dispatch(
        couponsActions.addToSelectedCoupons({
          coupon: props.coupon,
        })
      );
    }
  };

  const info = () => {
    dispatch(
      alertActions.createAlert({
        title: languageContext.getTranslation(appConst.COUPON_INFO_TITLE),
        message: props.coupon.terms_and_conditions,
        isDialog: false,
      })
    );
  };

  const serviceCodeInfo = () => {
    dispatch(
      alertActions.createAlert({
        title: languageContext.getTranslation(
          appConst.SERVICE_CODE_COUPON_INFO_TITLE
        ),
        message: props.coupon.terms_and_conditions,
        isDialog: false,
      })
    );
  };

  return (
    <div className="summary_coupon" style={{ display: "flex" }}>
      <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <div style={{ display: "flex", justifyContent: isRtl ? "flex-end" : "flex-start" }}>
          <div className={couponClasses}>
            <div
              className="rtl_column_box_position coupon_main_text"
              style={{ direction, textAlign: "start", display: "flex", flexDirection: "row", alignItems: "center", columnGap: "0.35rem" }}
            >
              <IconButton
                className="summary-icon-btn p-0"
                style={{ flexShrink: 0 }}
                data-testid="coupon-info-button"
                onClick={props.disabled ? serviceCodeInfo : info}
              >
                <Info className="color_green" size={20} />
              </IconButton>
              <div>
                <div className="box_item_l bold">
                  {props.coupon.title}
                </div>
                <div className="box_item_r">
                  {languageContext.getTranslation(appConst.VALIDITY)}
                  {new Date(props.coupon.expiration).toLocaleDateString("nl-NL")}
                </div>
                {isExpiringSoon && (
                  <div className="warning_color warning_font">
                    {languageContext.getTranslation(appConst.EXPIRING_SOON)}
                  </div>
                )}
              </div>
            </div>
            <div className="summary_box_item coupon_text_description">
              <div className="box_item_l">{props.coupon.description}</div>
            </div>
            <div className="coupon_tooltip" title={switchTitle}>
              <Switch
                checked={isChecked && !props.disabled}
                onCheckedChange={hendleChecked}
                disabled={props.disabled}
                className="coupon-switch"
                data-testid="coupon-toggle-switch"
              />
            </div>
          </div>
        </div>
        {props.coupon.messageError && (
          <div
            className="warning_color warning_font"
            style={{ direction, margin: "-8px 0 8px", textAlign: "start" }}
          >
            {props.coupon.messageError}
          </div>
        )}
      </div>
    </div>
  );
}
